import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';

@Component({
  selector: 'app-assembly-process-popup',
  templateUrl: './assembly-process-popup.component.html',
})
export class AssemblyProcessPopupComponent implements OnInit {
  public itemForm: FormGroup;

  public operationCodes: { code: string; name: string }[] = [];
  public filteredOpCodes: { code: string; name: string }[] = [];
  public costCentres: { code: string; name: string; rate: number }[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AssemblyProcessPopupComponent>,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.operationCodes = this.data.operationCodes || [];
    this.filteredOpCodes = [...this.operationCodes];
    this.costCentres = this.data.costCentres || [];
    this.buildItemForm(this.data.payload);
  }

  selectOpCode(event: MatAutocompleteSelectedEvent) {
    var op = this.operationCodes.find(x => x.code == event?.option.value);
    this.itemForm.controls['operationName'].setValue(op.name);

    if(op.code == 'SUBCO')
      this.itemForm.controls['isSubcontracted'].setValue(true);
  }
    
  filterOpCodes(event: any) {
      var text = event.target.value;
      this.filteredOpCodes = this.operationCodes.filter(m => m.name.toLowerCase().includes(text.toLowerCase()));
      // this.cdr.detectChanges();
  }

  costCentreChanged(event: MatSelectChange) {
      var code = event.value;
      var cc = this.costCentres.find(x => x.code == code);
      if(cc)
        this.itemForm.controls['costCentreRate'].setValue(cc.rate);
  }

  buildItemForm(item) {
    this.itemForm = this.fb.group({
      bomAssemblyProcessId: [item.bomAssemblyProcessId || null],
      sequence:             [item.sequence || null,                 [Validators.required, Validators.min(10)]],
      operationCode:        [item.operationCode || '',              Validators.required],
      operationName:        [item.operationName || '',              Validators.required],
      costCentreCode:       [item.costCentreCode || '',             Validators.required],
      costCentreRate:       [item.costCentreRate || 0,              [Validators.required, Validators.min(0)]],
      isSubcontracted:      [item.isSubcontracted || false],
      subcontractorName:        [item.subcontractorName || ''],
      subcontractorHourlyRate:  [item.subcontractorHourlyRate || 0, [Validators.min(0)]],
      setupHours:               [item.setupHours || 0,              [Validators.required, Validators.min(0)]],
      runPerUnitHours:          [item.runPerUnitHours || 0,         [Validators.required, Validators.min(0)]],
      notes:                    [item.notes || '']
    });
  }

  submit() {
    this.dialogRef.close(this.itemForm.value);
  }
}
